import script from "./custom-page-view.vue?vue&type=script&lang=ts&setup=true"
export * from "./custom-page-view.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__